import { useEffect, useRef } from 'react';
import { pb } from '@/core/api';
import { useAuthStore } from '@/stores/auth';
import type { AuthUser } from '@/types/auth';
import type { Countdown } from './use-countdown';

// When a collector's test countdown hits 0, ask the server to evaluate
// immediately (no waiting for the 1-min cron) and refresh local auth
// so route guards can redirect a just-banned user.
export function useTestPhaseWatchdog(
  user: AuthUser | null,
  countdown: Countdown | null
): void {
  const refreshAuth = useAuthStore((s) => s.refreshAuth);
  const triggered = useRef(false);

  useEffect(() => {
    if (triggered.current) return;
    if (user?.account_status !== 'test') return;
    if (!countdown?.expired) return;

    triggered.current = true;
    void pb
      .send('/api/team/me/check-test-phase', { method: 'POST' })
      .then(() => refreshAuth())
      .catch((err: unknown) => {
        console.error('[test-phase-watchdog]', err);
        triggered.current = false;
      });
  }, [user, countdown, refreshAuth]);
}
